export default __webpack_public_path__ + "static/media/crystallizedlotusextract.c695c8ef.png";